var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.pgVersion === _vm.index)?_c('div',{ref:"phenogridbox",attrs:{"id":'phenogridbox-'+_vm.index}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }